import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getProductSpecSheets, SpecSheet } from "../api/Product/ProductSpecSheetApi";
import { AppThunk } from "../app/store";

interface ProductSpecSheetState {
  specSheets: SpecSheet[] | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: ProductSpecSheetState = {
  specSheets: null,
  isLoading: false,
  error: null
};

const specSheets = createSlice({
  name: "specSheets",
  initialState,
  reducers: {
    getProductSpecSheetsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    getProductSpecSheetsSuccess(state, { payload }: PayloadAction<SpecSheet[]>) {
      state.isLoading = false;
      state.error = null;
      state.specSheets = payload;
    },
    getProductSpecSheetsFailure(state, { payload }: PayloadAction<string>) {
      state.isLoading = false;
      state.error = payload;
    }
  }
});

export const { getProductSpecSheetsStart, getProductSpecSheetsSuccess, getProductSpecSheetsFailure } =
  specSheets.actions;

export default specSheets.reducer;

export const fetchProductSpecSheets =
  (productIds: string[]): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(getProductSpecSheetsStart());
      const specSheets = await getProductSpecSheets(productIds);
      dispatch(getProductSpecSheetsSuccess(specSheets));
    } catch (err: any) {
      dispatch(getProductSpecSheetsFailure(err.toString()));
    }
  };
